<template>
  <div class="mark-detail-deal-wrap">
    <DetailPageWrap
      :titleCardOptions="titleCardOptions"
      :description="describe"
    >
      <template>
        <div class="card-wrap">
          <a-row :gutter="[8, 0]" type="flex">
            <a-col :span="18">
              <div class="result-wrap">
                <div class="right-wrap">
                  <div class="headerTitle">
                    <div class="title">
                      {{ result.name }}
                    </div>
                    <div
                      class="block"
                      v-if="result.tag && result.tag !== null"
                      :title="result.tag"
                    >
                      {{ result.tag }}
                    </div>
                    <div class="favorite">
                      <span class="iconItem">
                        <a-icon type="eye" :style="{ color: '#364759' }" />
                        <span>{{ result.browseNum }}</span>
                      </span>
                    </div>
                  </div>
                  <span class="line"></span>
                  <div class="mark-card-body-wrap">
                    <div>{{ user.enpName }}</div>
                    <div>需求类型：{{ result.demandsTypeStr || '-' }}</div>
                    <div>
                      价格：<span class="price">{{
                        result.priceRange === -1
                          ? '面议'
                          : '￥' + result.priceRange
                      }}</span>
                    </div>
                    <div>技术分类：{{ result.technicalTypeStr || '-' }}</div>
                    <div>产业分类：{{ result.industrialTypeStr || '-' }}</div>
                    <div>发布时间：{{ result.publishTime || '-' }}</div>
                  </div>
                  <!-- <a-button class="toDetailBtn" @click="goSearch(result)"
                    >查看详情</a-button
                  > -->
                </div>
              </div>
            </a-col>
            <a-col :span="6">
              <SideWrap iconName="iconPhone.png" type="img" title="联系方式">
                <template>
                  <div class="side-body-wrap">
                    <div class="user-head">
                      <img src="/static/iconAvator.png" alt="" />
                    </div>
                    <div>联系人: {{ user.userName }}</div>
                    <div>电话: {{ user.enpPhone }}</div>
                    <div>邮箱: {{ user.email }}</div>
                  </div>
                </template>
              </SideWrap>
            </a-col>
          </a-row>
        </div>
      </template>
    </DetailPageWrap>
  </div>
</template>

<script>
import DetailPageWrap from '@/components/common/DetailPageWrap'
import SideWrap from '@/views/MTradingMarket/components/SideWrap.vue'
import { titleCardOptions } from './data'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { productDataBase } from '@/api/competitor'
import { demandId } from '@/api/technicalR'
const industryList = require('@/utils/industryList')
export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      titleCardOptions,
      result: {},
      baseInfos: {},
      user: {},
      describe: [],
      collectStatus: 'outlined',
      collectColor: { color: '#364759' },
      colors: {
        0: '#89C997', // 转让
        1: '#6582FF', // 许可
        2: '#2279D2' // 质押
      },
      is_collect: false
    }
  },
  components: {
    DetailPageWrap,
    SideWrap
  },
  created() {
    this.initDefaultValue()
  },
  methods: {
    goSearch(val) {
      // console.log(val);
      productDataBase().then(res => {
        const { access_token } = res.data
        const { refresh_token } = res.data
        window.open(
          `${window.APP_NAME.BASE_URL}?token=${access_token}&refresh_token=${refresh_token}&an=${val.applyNum}&pn=${val.publicNum}`
        )
        // window.open(`http://localhost:8083?token=${access_token}&refresh_token=${refresh_token}&an=${val.applyNum}&pn=${val.publicNum}`)
      })
    },
    async initDefaultValue() {
      const { id } = this.$route.query
      const { data } = await demandId(id)
      // const datas = [data]
      let industList = industryList.industryList
      let techList = [
        { label: '人类生活必需', value: '0' },
        { label: '作业；运输', value: '1' },
        { label: '化学；冶金', value: '2' },
        { label: '纺织；造纸', value: '3' },
        { label: '固定建筑物', value: '4' },
        { label: '机械工程；照明；加热；武器；爆破', value: '5' },
        { label: '物理', value: '6' },
        { label: '电学', value: '7' }
      ]
      let demandsList = [
        { name: '技术难题', value: '1', key: 'demandsType1' },
        { name: '产品需求', value: '2', key: 'demandsType2' },
        { name: '服务需求', value: '3', key: 'demandsType3' },
        { name: '其他需求', value: '4', key: 'demandsType4' },
        { name: '不限', value: '', key: 'demandsType' }
      ]
      // const row = this.handlerDateFormat(datas)
      // this.handlerResultMappings(row) // 处理数据的映射关系
      this.result = data
      demandsList.forEach(item => {
        if (item.value === this.result.demandsType) {
          this.result.demandsTypeStr = item.name
        }
      })
      industList.forEach(item => {
        if (item.value === this.result.industrialType) {
          this.result.industrialTypeStr = item.label
        }
      })
      techList.forEach(item => {
        if (item.value === this.result.technicalType) {
          this.result.technicalTypeStr = item.label
        }
      })
      this.dealBaseInfo(this.result)
      if (data.user !== null) {
        this.user = data.user
      }
      this.describe = [
        {
          title: '',
          contents: []
        }
      ]
      this.describe[0].contents.push(this.result.describe)
    },
    // 处理用户的基本信息
    dealBaseInfo(result) {
      const info = result.patent
      if (!info) return
      const { applicants_stat, assignees, inventors, ...otherParams } = info
      this.baseInfos = {
        ...otherParams,
        applicants_stat: applicants_stat.join(','),
        assignees: assignees.join(','),
        inventors: inventors.join(',')
      }
    }
  }
}
</script>
